<template>
  <div class="customer-ratings">
    <b-row>
      <b-col md="12" class="mb-4" v-if="(editable || offer.showCustomerReviews) && display">
        <Reviews 
          :name="$t('reviews.companyName')"
          :heading="heading" 
          :review="companyRating" 
          :hideAt="hideAt"
          :constituents="constituents"
          show-author show-date
          id="customerReviews"
          @toggle="(value) => offerSet({showCustomerReviews: value ? 1 : 0})"
          @dirty="() => $emit('dirty')"
          :editable="editable"
          :initial="offer.showCustomerReviews === 1 ? true : false"
        />
      </b-col>
    </b-row>
    <hr v-if="offer.showSeminarReviews && display"/>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Reviews from './Reviews'

export default {
  name:'CompanyReviews',
  components: {Reviews},
  props: {
    editable: Boolean,
  },
  data() {
    return {
      constituents: ['gfuReview', 'seminarReview'],
      hideAt: 3
    }
  },
  methods: {
    ...mapMutations(['offerSet'])
  },
  computed: {
    ...mapGetters(['companyRating', 'offer']),
    heading() {
      return this.$t('reviews.companyHeading');
    },
    display() {
      return this.companyRating && (this.companyRating.length != 0)
    }
  }
}
</script>
